const TFA_TYPE = {
  DISABLED: 0,
  TOTP: 1,
  AUTHY: 2,
};

export default TFA_TYPE;
